import { useParams } from 'react-router-dom';
import { ProjectPagina } from '@/features/projectpagina/ProjectPagina';

/* /crm/projects/:projectId. De route staat in App.tsx (V1-lock); de pagina zelf
   is de projectpagina in src/features/projectpagina (ADR 0017). */
export default function CRMProjectDetail() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return null;
  return <ProjectPagina key={projectId} projectId={projectId} />;
}
